<script>
  import ClickOut from '../../../../utils/directives/clickout'
  import { mapGetters } from 'vuex'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser'])
    },
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
    <li class="dropdown" :class="{ open: open }">
        <a href="javascript://" class="dropdown-toggle clear" data-toggle="dropdown" v-click-out="hide" @click="toggle">
            <span class="thumb-sm avatar pull-right m-t-n-sm m-b-n-sm m-l-sm">
                <img v-bind:src="currentUser.foto" v-bind:alt="currentUser.nome">
                <i class="on md b-white bottom"></i>
            </span>
            <span class="hidden-sm hidden-md">{{ currentUser.nome && currentUser.nome.split(' ').shift() }}</span> <b class="caret"></b>
        </a>
        <!-- dropdown -->
        <ul class="dropdown-menu animated fadeInRight w">
            <!--<li class="wrapper b-b m-b-sm bg-light m-t-n-xs">-->
                <!--<div>-->
                    <!--<p>300mb of 500mb used</p>-->
                <!--</div>-->
                <!--<div class="progress progress-xs m-b-none dker">-->
                    <!--<div class="progress-bar progress-bar-info" data-toggle="tooltip" data-original-title="50%"-->
                         <!--style="width: 50%"></div>-->
                <!--</div>-->
            <!--</li>-->
            <li><a href="javascript://"><span>Configurações</span> </a>
            </li>
            <li><a ui-sref="app.page.profile">Perfil</a></li>
            <li><a ui-sref="app.docs">Ajuda </a></li>
            <li class="divider"></li>
            <li><router-link :to="{ name: 'logout' }">Sair</router-link></li>
        </ul>
        <!-- / dropdown -->
    </li>
</template>



// WEBPACK FOOTER //
// Profile.vue?5dfb6a3d